import {templateValueSeparator} from './constants';

export const createSelectTemplateValue = (value: number, isWordTmpl: boolean) => {
    return `${value}${templateValueSeparator}${isWordTmpl}`;
};
